/**
 * Stored on chart/query `where` (JSON string). Use {@link resolveChartWhereForApi} before
 * `dataFilter` requests: date bounds become absolute YYYY-MM-DD; belongsTo stays `{ targetEntryId }`.
 */
export type ChartDateBound = string | { relativeDays: number };

export type ChartDateFieldFilter =
	| { start?: ChartDateBound; end?: ChartDateBound }
	| { isUnset: true };

/** BelongsTo filter: single linked target entry id (repository entry in the target repo). */
export interface ChartBelongsToFieldFilter {
	targetEntryId: string;
}

/** Root object: property slug → date range and/or belongsTo target (partitioned in the UI). */
export type ChartWhereDocument = Record<string, ChartDateFieldFilter | ChartBelongsToFieldFilter>;

export function isChartRelativeBound(value: unknown): value is { relativeDays: number } {
	return (
		value !== null
		&& typeof value === 'object'
		&& !Array.isArray(value)
		&& typeof (value as { relativeDays?: unknown }).relativeDays === 'number'
		&& Number.isFinite((value as { relativeDays: number }).relativeDays)
	);
}
